<template>
  <div class="container">
      <h3 class="heading"> نوع الشكوى</h3>

      <form @submit.prevent="postinfo">
        

  <div class="mb-3 input-in-con ">
      <div v-if="err">
  <div v-if="err.name"  class="alert alert-danger" role="alert"> {{ err.name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">نوع الشكوى </label>
  <input type="text"   class="form-control " id="exampleFormControlInput1" placeholder="ادخل  النوع  " v-model="formdata.name">
</div>

 


<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>
</template>

<script setup>

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import  geturl  from "@/comp/geturl";

const formdata = ref({
  name:"",
})
const err = ref(null)
const router = useRouter()

const postinfo = ()=>{

  fetch(geturl()+"complaints/complaint_type/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(formdata.value)
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          err.value = data.error.details
                  }
      else{
        router.push({name:'Complaint_TypeView' })
      }
      })

}

</script>

<style>

</style>